import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ih_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const waLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
};
